import SmoothScrollIntoView from '../__utils/smoothScrollIntoView';
import {
	readHeaderHeight,
	writeHeaderHeight,
} from '../__utils/setHeaderHeight';
import Forms from '../__utils/forms';
import {
	readViewportUnits,
	writeViewportUnits,
} from '../__utils/viewportUnits';
import delayedScripts from '../__utils/delayedScripts';

// One read pass then one write pass; interleaving them forces a reflow per read.
const setLayoutCustomProperties = () => {
	const headerMeasurements = readHeaderHeight();
	const viewportMeasurements = readViewportUnits();

	writeHeaderHeight(headerMeasurements);
	writeViewportUnits(viewportMeasurements);
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		document.querySelector('html').classList.remove('no-js');
		SmoothScrollIntoView();
		setLayoutCustomProperties();
		delayedScripts();
	},
	loaded() {
		// Only add functions here that are okay to run after the entire page has loaded (include media/images).
		Forms();
		setLayoutCustomProperties();
	},
	resized() {
		setLayoutCustomProperties();
	},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
